import React, { useEffect, useRef, Fragment, useState, useMemo } from 'react';
import { Send, X, Phone, Video, Minimize, Maximize, ChevronUp, MessageSquareText, contact, UserRound, Expand, Shrink, SquareArrowOutUpRight, ArrowUpFromLine, File, Upload, Users, Search, CheckCheck, BotIcon, Reply, Star, Trash2, } from 'lucide-react';
import { useAuth } from "./AuthContext";
import { useChatContext } from "./ChatProvider";
import VideoPlayer from './components/VideoPlayer';
import AudioPlayer from './components/AudioPlayer';
import LinkHighlighter from './components/LinkHighlighter';
import BeautifiedCodeViewer from './components/BeautifiedCodeViewer';
import PreviewDialog from './components/PreviewDialog';
import MapCard from './components/MapCard';
import UserChat from './chats/UserChat';
import GroupChat from './chats/GroupChat';


const ChatWindows = (props) => {


    const { color, noOfChat, senderContainerColor, senderTextColor, receiverContainerColor, receiverTextColor, sendButtonColor, chatWidth, chatHeight, cognitoUserId, email, senderDateTextColor, receiverDateTextColor,
        senderLinkTextColor, receiverLinkTextColor, groupUserNameColors,
        ctaButtonColor, ctaButtonText, headerTextColor
    } = props


    const {
        activeChats,
        minimizedChats,
        newMessage,
        messageEndRef,
        toggleMinimize,
        closeChat,
        handleMessageChange,
        sendMessage,
        handleKeyDown,
        handleUserClick,
        minimizedContact, setMinimizedContact,

        activeTab,
        handleSwitchTab,
        fetchChatUserList,
        userList,
        contactList,
        maxChat, setMaxChat,
        messages, setMessages,
        chats, setChats,
        messageAlert, setMessageAlert,
        handleAttachmentClick,
        fileInputRef,
        handleFileSelect,
        showPreviewDialog, isImageFile, handleCancelFileUpload, formatFileSize,
        fileToUpload,
        fetchUploadFileApi,
        isDragging,
        handleDragOver, handleDragEnter, handleDragLeave, handleDrop,
        dropAreaRef,
        setToUser,
        textareaRef,
        toUser,
        messageWorkchatAlert,
        setMessageWorkchatAlert,
        messageWorkchatUserAlert, setMessageWorkchatUserAlert,
        handleSendGroupMessage,
        searchContactVal,
        handleContactSearch,
        searchVal,
        handleSearchUser,
        replyMessageData, setReplyMessageData,
        handleReplyMessage,
        showModal,
        modalRef, setShowModal,
        groupInputRef,
        filteredMentionGroupMembers,
        handleMentionUserSelect,
        autoResizeTextarea,
        messagesContainerRef, scrollToMessage, setHighlightReply, highlightReply,
        handleDeleteMessage,
        handleDeleteGroupMessage,
        activeChatOptions, handleChatFilter,
        setActiveChatOptions,
        handleBotSend,
        setOpenChatUserId,
        isDisableMcpInput






    } = useChatContext();
    const { handleCognitoVerification } = useAuth()
    // const authUserId = localStorage.getItem("authUser");
    let authUserId = null;
    if (typeof window !== "undefined") {
        authUserId = localStorage.getItem("authUser");
    }
    const [page, setPage] = useState(1);
    const pageSize = 10;


    const checkFileType = (val) => {

        let split = val.split("/")[0]

        return split

    }
    const formatFile = (val) => {

        const type = val.split('.').at(-1);
        const extWithDot = `.${type}`;
        return extWithDot
    }




    useEffect(() => {
        fetchChatUserList()
    }, [])
    useEffect(() => {
        if (!noOfChat) return
        setMaxChat(noOfChat)
    }, [])


    useEffect(() => {

        // if (!cognitoUserId?.trim() == "" && !email?.trim() == "") {
        handleCognitoVerification(cognitoUserId, email)
        // }



    }, [cognitoUserId, email])


    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
        if (newWindow) newWindow.opener = null
    }

    const [expandChat, setExpandChat] = useState(false)


    const isProbablyCode = (text) => {
        const codePatterns = [
            /<[\w\d]+\s?.*?>/,         // HTML/JSX tag: <div> or <Workchat />
            /\bfunction\b|\bconst\b/,  // JavaScript keywords
            /\bdef\b|\bimport\b/,      // Python keywords
            /=\s*{.*?}/,               // React prop-style expressions
            /<\/[\w\d]+>/              // closing tags
        ];
        return codePatterns.some(pattern => pattern.test(text));
    };
    const formatDate = (isoString,) => {
        const date = new Date(isoString);
        const now = new Date();

        const isToday = date.toDateString() === now.toDateString();

        if (isToday) {
            return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        }

        return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
    };


    const getColorByName = (name) => {
        const index = name?.charCodeAt(0) % groupUserNameColors.length;
        return groupUserNameColors[index];
    };


    useEffect(() => {

        if (replyMessageData && showModal) {
            setExpandChat(true)
        }

    }, [replyMessageData, showModal])

    const tabs = ['All', 'Unread', 'Groups', 'AI',];



    return (
        <div className="fixed bottom-0 right-0 flex gap-4 z-50 ">

            {/* Render all active chat windows */}
            {activeChats.length > 0 && activeChats.map((userId, i) => {
                const storedList = JSON.parse(localStorage.getItem('userListStore') || '[]');

                const user =
                    userList?.find(u => u?._id === userId)
                    || contactList?.find(u => u?._id === userId)
                    || storedList?.find(u => u?._id === userId)
                    || userList?.find(u => u?.userId?._id === userId)
                    || "";
                const chatMessages = (chats[userId] || []);
                const isMinimized = minimizedChats.includes(userId);
                setMessageWorkchatUserAlert(isMinimized)
                setOpenChatUserId(userId)
                return (
                    <div
                        key={i + 1}
                        className="w-64  bg-white rounded-t-lg shadow-lg flex flex-col self-end "
                        style={{
                            height: isMinimized
                                ? '40px'
                                : expandChat
                                    ? '550px'
                                    : chatHeight,
                            width: expandChat
                                ? '500px'
                                : chatWidth,
                        }}
                        ref={dropAreaRef}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDragLeave={handleDragLeave}
                        onDrop={handleDrop}
                    >

                        {/* {isDragging && (
                            <div className="absolute inset-0 z-50  bg-white/80 backdrop-blur-sm flex items-center justify-center pointer-events-none">
                                <div className="bg-blue-100 border border-blue-300 p-8 rounded-lg shadow-md text-center ">
                                    <Upload size={48} className="mx-auto text-primary mb-2" />
                                    <p className="text-lg font-medium">Drop file here</p>
                                    <p className="text-sm text-gray-500">to upload and send</p>
                                </div>
                            </div>
                        )} */}
                        {/* Header */}
                        <div className="px-3 py-2 border-b flex items-center justify-between rounded-t-lg"
                            style={{
                                backgroundColor: color || "#000",

                            }}

                        >
                            <div
                                className="flex items-center cursor-pointer flex-1"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    toggleMinimize(userId);
                                    setMessageAlert(false)

                                }}
                            >
                                <div className="relative">
                                    {user?.profileImage ? <img
                                        src={user?.profileImage}
                                        alt={user.name.charAt(0)}
                                        className="w-8 h-8 rounded-full text-center justify-center items-center border flex text-white"
                                    /> : user?.type === 'group' ? <span className="w-8 h-8 rounded-full text-center justify-center items-center border flex text-white"
                                    ><Users /></span> : <span className="w-8 h-8 rounded-full text-center justify-center items-center border flex text-white"
                                    >{user?.name?.charAt(0)}</span>}
                                    {user?.status === 'available' && (
                                        <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-blue-600"></div>
                                    )}
                                </div>
                                <div className="ml-2">
                                    <div className="font-medium  text-sm"
                                        style={{ color: headerTextColor || "#fff" }}
                                    >{user?.name || ""}</div>
                                    {user.type === "bot" && <div className="font-medium text-white text-[10px]">BOT</div>}

                                </div>
                                {(isMinimized && messageAlert) && <div className='bg-red-600 w-4 h-4 text-xs text-center rounded ml-1'>1</div>
                                }
                            </div>

                            <div className="flex space-x-2">
                                {(!isMinimized) && <div>
                                    {
                                        !expandChat ? <Expand size={16}
                                            className="text-white cursor-pointer"

                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setExpandChat(!expandChat);

                                            }}
                                        /> :
                                            <Shrink size={16}
                                                className="text-white cursor-pointer"

                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setExpandChat(!expandChat);

                                                }}
                                            />
                                    }</div>}
                                {isMinimized ? (
                                    <Maximize
                                        size={16}
                                        className="text-white cursor-pointer"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleMinimize(userId);
                                            setMessageAlert(false)
                                        }}
                                    />
                                ) : (
                                    <Minimize
                                        size={16}
                                        className="text-white cursor-pointer"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            toggleMinimize(userId);
                                        }}
                                    />
                                )}
                                <X
                                    size={16}
                                    className="text-white cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        closeChat(userId);
                                        setMessageWorkchatUserAlert(false)
                                    }}
                                />
                            </div>
                        </div>

                        {/* Chat content */}
                        {isDragging ? <div className="flex items-center justify-center pointer-events-none h-full">
                            <div className="bg-blue-100 border border-blue-300 p-8 rounded-lg shadow-md text-center ">
                                <Upload size={48} className="mx-auto text-primary mb-2" />
                                <p className="text-lg font-medium">Drop file here</p>
                                <p className="text-sm text-gray-500">to upload and send</p>
                            </div>
                        </div> : !isMinimized &&
                        <>
                            {user.type === "user" &&
                                <>
                                    <UserChat chatMessages={chatMessages}
                                        highlightReply={highlightReply}
                                        senderContainerColor={senderContainerColor}
                                        receiverContainerColor={receiverContainerColor}
                                        senderTextColor={senderTextColor}
                                        receiverTextColor={receiverTextColor}
                                        messagesContainerRef={messagesContainerRef}
                                        scrollToMessage={scrollToMessage}
                                        authUserId={authUserId}
                                        checkFileType={checkFileType}
                                        openInNewTab={openInNewTab}
                                        formatFile={formatFile}
                                        isProbablyCode={isProbablyCode}
                                        handleReplyMessage={handleReplyMessage}
                                        handleDeleteMessage={handleDeleteMessage}
                                        senderDateTextColor={senderDateTextColor}
                                        receiverDateTextColor={receiverDateTextColor}
                                        color={color}
                                        senderLinkTextColor={senderLinkTextColor}
                                        receiverLinkTextColor={receiverLinkTextColor}
                                        replyMessageData={replyMessageData}
                                        sendButtonColor={sendButtonColor}
                                        setReplyMessageData={setReplyMessageData}
                                        userId={userId}




                                    />



                                    <div className="p-2 border-t">
                                        <div className="flex items-center">
                                            <button
                                                className="mr-2 p-1 rounded-full bg-blue-500 text-white "
                                                style={{ backgroundColor: sendButtonColor || "#000" }}
                                                onClick={() => handleAttachmentClick(userId)}                                        >
                                                <ArrowUpFromLine size={16} />
                                            </button>
                                            <input
                                                type="file"
                                                ref={fileInputRef}
                                                onChange={handleFileSelect}
                                                className="hidden"
                                            />

                                            <textarea
                                                ref={(el) => (textareaRef.current[userId] = el)}
                                                className="flex-1 border rounded-lg py-1 max-h-60 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 resize-none px-2 overflow-auto no-scrollbar"
                                                placeholder="Type a message..."
                                                autoFocus
                                                value={newMessage[userId] || ''}
                                                onChange={(e) => {
                                                    handleMessageChange(userId, e.target.value);
                                                    autoResizeTextarea(userId); // Adjust height
                                                }}
                                                onKeyDown={(e) => handleKeyDown(userId, e)}
                                                rows={1}

                                            />

                                            <button
                                                className="ml-2 p-1 rounded-full bg-blue-500 text-white "
                                                style={{ backgroundColor: sendButtonColor || "#000" }}
                                                onClick={() => sendMessage(userId)}
                                            >
                                                <Send size={16} />
                                            </button>
                                        </div>
                                    </div>







                                </>
                            }


                            {user.type === "group" && <>

                                <GroupChat
                                    chatMessages={chatMessages}
                                    messagesContainerRef={messagesContainerRef}
                                    user={user}
                                    highlightReply={highlightReply}
                                    // isReceiver={isReceiver}
                                    getColorByName={getColorByName}

                                    senderContainerColor={senderContainerColor} receiverContainerColor={receiverContainerColor} senderTextColor={senderTextColor}
                                    receiverTextColor={receiverTextColor}
                                    authUserId={authUserId}
                                    checkFileType={checkFileType}
                                    openInNewTab={openInNewTab}
                                    formatFile={formatFile}
                                    isProbablyCode={isProbablyCode}
                                    handleReplyMessage={handleReplyMessage}
                                    handleDeleteGroupMessage={handleDeleteGroupMessage}
                                    senderDateTextColor={senderDateTextColor}
                                    receiverDateTextColor={receiverDateTextColor} headerTextColor={headerTextColor}
                                    scrollToMessage={scrollToMessage}
                                    color={color}
                                    senderLinkTextColor={senderLinkTextColor}
                                    receiverLinkTextColor={receiverLinkTextColor}


                                />





                                {showModal && (
                                    <div
                                        ref={modalRef}
                                        className=" bg-white rounded-lg shadow-2xl border border-gray-200 z-50  overflow-hidden animate-slide-up w-[96%] self-center max-h-80"


                                    >
                                        <div className="p-3 border-b border-gray-100 bg-gray-50 flex justify-between items-center">
                                            <h3 className="text-sm font-medium text-gray-700">Select member to mention</h3>
                                            <div onClick={() => setShowModal(false)}>
                                                <X size={16} />
                                            </div>
                                        </div>

                                        <div className=" max-h-60 overflow-y-auto ">
                                            {filteredMentionGroupMembers.length > 0 ? (
                                                filteredMentionGroupMembers.map((contact) => {
                                                    let removeUser = contact.userId._id != authUserId
                                                    return (
                                                        removeUser && <div
                                                            key={contact._id}
                                                            onClick={() => handleMentionUserSelect(contact)}
                                                            className="flex items-center gap-3 p-3 hover:bg-gray-200 cursor-pointer transition-colors"
                                                        >
                                                            {/* Avatar */}
                                                            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-300 overflow-hidden border">
                                                                {contact?.userId?.profileImage ? (
                                                                    <img
                                                                        src={contact.userId.profileImage}
                                                                        alt={contact.userId.name?.charAt(0)}
                                                                        className="w-full h-full object-cover"
                                                                    />
                                                                ) : (
                                                                    <span className="text-sm font-medium text-black">
                                                                        {contact.userId.name?.charAt(0)}
                                                                    </span>
                                                                )}
                                                            </div>

                                                            {/* Name */}
                                                            <div className="flex-1">
                                                                <p className="font-medium text-gray-900 text-sm">
                                                                    {contact.userId.name}
                                                                </p>
                                                            </div>
                                                        </div>

                                                    )
                                                })
                                            ) : (
                                                <div className="p-4 text-center text-gray-500">
                                                    <p className="text-sm">No contacts found</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}

                                {replyMessageData && (
                                    <div className="px-4 py-2 bg-gray-100 border-b border-gray-200 flex items-start sm:items-center ">
                                        <div className="w-1 h-12  rounded-full mr-3 flex-shrink-0"
                                            style={{ backgroundColor: sendButtonColor || "#000" }}
                                        ></div>


                                        <div className="flex-1 min-w-0"> {/* min-w-0 allows text truncation */}
                                            <div className="flex items-center justify-between gap-2">
                                                <span className="text-xs font-medium text-gray-600 whitespace-nowrap">
                                                    Replying to {replyMessageData.sender === "reciver" ? replyMessageData.user.name : "You"}
                                                </span>
                                                <button
                                                    onClick={() => setReplyMessageData('')}
                                                    className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0"
                                                >
                                                    <X className="w-4 h-4" />
                                                </button>
                                            </div>

                                            <p className="text-sm text-gray-800 mt-1 w-full line-clamp-2">
                                                {replyMessageData?.text}
                                            </p>
                                        </div>
                                    </div>

                                )}
                                {/* Group message Input */}
                                <div className="p-2 border-t">
                                    <div className="flex items-center">
                                        <button
                                            className="mr-2 p-1 rounded-full bg-blue-500 text-white "
                                            style={{ backgroundColor: sendButtonColor || "#000" }}
                                            onClick={() => handleAttachmentClick(userId)}                                        >
                                            <ArrowUpFromLine size={16} />
                                        </button>
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            onChange={handleFileSelect}
                                            className="hidden"
                                        />

                                        <textarea
                                            ref={(el) => {
                                                groupInputRef.current = el;
                                                textareaRef.current[userId] = el;
                                            }}
                                            className="flex-1 border rounded-lg py-1 max-h-60 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 resize-none px-2 overflow-auto no-scrollbar"
                                            placeholder="Type a message..."
                                            autoFocus
                                            value={newMessage[userId] || ''}
                                            onChange={(e) => {
                                                handleMessageChange(userId, e.target.value);
                                                autoResizeTextarea(userId); // Adjust height
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && !e.shiftKey) {
                                                    e.preventDefault();
                                                    handleSendGroupMessage(userId)
                                                }
                                            }}
                                            rows={1}

                                        />

                                        <button
                                            className="ml-2 p-1 rounded-full bg-blue-500 text-white "
                                            style={{ backgroundColor: sendButtonColor || "#000" }}
                                            onClick={() => handleSendGroupMessage(userId)}
                                        >
                                            <Send size={16} />
                                        </button>
                                    </div>
                                </div>



                            </>}
                            {user.type === "bot" && <>

                                <div className="flex-1 p-3 overflow-y-auto flex flex-col-reverse">
                                    {[...chatMessages].map((chat, chatIndex) => (
                                        <div key={chatIndex + 1}>
                                            <div className="text-xs bg-primary/20 text-primary px-2 py-1 mx-auto my-4 backdrop-blur-sm border-b w-full flex items-center justify-center border-gray-500">
                                                {chat?.date}
                                            </div>

                                            {[...chat.chats].reverse().map((message, index) => {
                                                const isMe = message.sender === 'me';
                                                const isReceiver = message.sender === 'reciver';

                                                return (
                                                    <div
                                                        key={index + 1}
                                                        className={`mb-2 flex ${isMe ? 'justify-end' : 'justify-start'}`}
                                                    >


                                                        <div className="flex flex-col max-w-[80%]">
                                                            {isReceiver && (
                                                                <span
                                                                    className="text-xs font-semibold mb-1"
                                                                // style={{ color: getColorByName(message?.name) }}
                                                                >
                                                                    {message?.name}
                                                                </span>
                                                            )}

                                                            <div
                                                                className={`p-2 rounded-lg shadow-md break-words whitespace-pre-wrap ${isMe
                                                                    ? 'bg-blue-500 text-white rounded-br-none'
                                                                    : 'bg-gray-200 text-gray-800 rounded-bl-none'
                                                                    }`}
                                                                style={{
                                                                    backgroundColor: isMe ? senderContainerColor : receiverContainerColor,
                                                                    color: isMe ? senderTextColor : receiverTextColor
                                                                }}
                                                            >
                                                                {/* Render file type previews */}
                                                                {checkFileType(message.fileType) === 'image' && (
                                                                    <div className="flex justify-center items-center mb-1">
                                                                        <img
                                                                            onClick={() => openInNewTab(message.link)}
                                                                            src={message.link}
                                                                            alt="Preview"
                                                                            className="max-h-28 rounded cursor-pointer"
                                                                        />
                                                                    </div>
                                                                )}

                                                                {checkFileType(message.fileType) === 'video' && (
                                                                    <VideoPlayer src={message.link} color={color} />
                                                                )}

                                                                {checkFileType(message.fileType) === 'audio' && (
                                                                    <AudioPlayer src={message.link} color={color} />
                                                                )}

                                                                {checkFileType(message.fileType) === 'application' && (
                                                                    <div
                                                                        className="flex items-center bg-gray-100 p-2 rounded cursor-pointer mb-1"
                                                                        onClick={() => openInNewTab(message.link)}
                                                                    >
                                                                        <File size={20} className="text-black mr-2" />
                                                                        <p className="text-sm text-black">Document{formatFile(message.link)}</p>
                                                                    </div>
                                                                )}

                                                                {/* Render text/code */}
                                                                <div className="text-sm">
                                                                    {/* {!isProbablyCode(message.text) && checkFileType(message.fileType) != "image" && message.text !== '' && message.type !== 'L' && (
                                                                        <LinkHighlighter
                                                                            text={message.text}
                                                                            color={isMe ? senderLinkTextColor : receiverLinkTextColor}
                                                                        />
                                                                    )} */}
                                                                    {<LinkHighlighter text={message.text} color={message.sender === 'me' ? "#fff" : "Blue"} />}

                                                                    {(isProbablyCode(message?.text) && message?.text) && <BeautifiedCodeViewer code={message?.text} />}
                                                                </div>
                                                                {message?.type === "cta" &&
                                                                    message?.ctaData?.map((btn, i) => (
                                                                        <div
                                                                            key={i + 1}

                                                                            className="px-3 py-1 text-xs w-full justify-center mt-2  text-white rounded-md hover:bg-primary flex items-center disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer"
                                                                            style={{ backgroundColor: ctaButtonColor || "#000", color: ctaButtonText || "#fff" }}
                                                                            onClick={() => window.open(btn?.url, '_blank', 'noopener,noreferrer')}
                                                                        >

                                                                            {btn.label}
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>

                                                            <span
                                                                className="text-xs mt-1 self-start"
                                                                style={{
                                                                    color: isMe ? senderDateTextColor : receiverDateTextColor
                                                                }}
                                                            >
                                                                {message.time}
                                                            </span>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    ))}
                                </div>


                                {/* Bot message Input */}
                                {isDisableMcpInput && <div className="p-2 border-t">
                                    <div className="flex items-center">
                                        {/* <button
                                            className="mr-2 p-1 rounded-full bg-blue-500 text-white "
                                            style={{ backgroundColor: sendButtonColor || "#000" }}
                                            onClick={() => handleAttachmentClick(userId)}                                        >
                                            <ArrowUpFromLine size={16} />
                                        </button> */}
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            onChange={handleFileSelect}
                                            className="hidden"
                                        />

                                        <textarea
                                            ref={(el) => {
                                                groupInputRef.current = el;
                                                textareaRef.current[userId] = el;
                                            }}
                                            className="flex-1 border rounded-lg py-1 max-h-60 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500 resize-none px-2 overflow-auto no-scrollbar"
                                            placeholder="Type a message..."
                                            autoFocus
                                            value={newMessage[userId] || ''}
                                            onChange={(e) => {
                                                handleMessageChange(userId, e.target.value);
                                                autoResizeTextarea(userId); // Adjust height
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter' && !e.shiftKey) {
                                                    e.preventDefault();
                                                    handleBotSend(userId)
                                                }
                                            }}
                                            rows={1}

                                        />

                                        <button
                                            className="ml-2 p-1 rounded-full bg-blue-500 text-white "
                                            style={{ backgroundColor: sendButtonColor || "#000" }}
                                            onClick={() => handleBotSend(userId)}
                                        >
                                            <Send size={16} />
                                        </button>
                                    </div>
                                </div>}



                            </>}

                        </>
                            // group mesage

                        }
                    </div>
                );
            })}

            {/* Optional: Floating HomeScreen widget */}
            {/* <div
                className="w-72 bg-white rounded-t-lg shadow-lg flex flex-col "
                style={{ maxHeight: minimizedContact ? '36px' : '550px', alignSelf: minimizedContact ? 'end' : '' }}
            > */}
            <div
                className={`bg-white rounded-t-lg shadow-lg flex flex-col 
  transition-all duration-300 ease-in-out
  w-72 max-w-md sm:max-w-md md:max-w-lg
  ${minimizedContact ? "max-h-[36px] self-end" : "max-h-[80vh] sm:max-h-[500px] md:max-h-[550px]"}
`}
            >
                <div className={`px-3 py-2 border-b flex items-center justify-between rounded-t-lg`}
                    style={{ backgroundColor: color || "#000" }}
                >
                    <div
                        className="flex items-center cursor-pointer flex-1"
                        onClick={(e) => {
                            e.stopPropagation();
                            toggleMinimize(0);
                            setMinimizedContact(!minimizedContact)
                            fetchChatUserList()
                            setMessageWorkchatAlert(false)
                            setActiveChatOptions('All')

                        }}
                    >
                        <div className="ml-2 flex gap-1 items-center justify-center">
                            <div className="font-medium text-white text-sm">Workchat  </div>
                            <a
                                href={"https://chat.nte.ai/app"}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <SquareArrowOutUpRight size={16}
                                    className="text-white cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();

                                    }} />
                            </a>
                            <span className={`text-xs ${(!messageWorkchatUserAlert && (minimizedContact && messageWorkchatAlert)) && 'bg-white'} text-black rounded-xl px-2 py-1 ${messageWorkchatAlert ? 'animate-blink' : ''}`}>
                                {!messageWorkchatUserAlert && (minimizedContact && messageWorkchatAlert) && "New Message"}
                            </span>                   </div>
                    </div>
                    <div className="flex space-x-2">
                        <ChevronUp
                            size={16}
                            className="text-white cursor-pointer"
                            onClick={(e) => {
                                e.stopPropagation();
                                setMinimizedContact(!minimizedContact)
                                setMessageWorkchatAlert(false)


                            }}
                        />
                    </div>
                </div>
                {!minimizedContact && <div className="flex-1 overflow-y-auto no-scrollbar">
                    <header className=" text-white text-center sticky top-0 z-50 ">
                        <div className="w-full max-w-[99%] mx-auto">
                            <div className="flex border-b border-gray-300 bg-white rounded-md overflow-hidden">
                                <button
                                    onClick={() => handleSwitchTab("chat")}
                                    className={`flex items-center px-4 py-2 text-sm font-medium border-b-2 justify-center w-full transition-colors ${activeTab === "chat"
                                        ? "border-blue-500 text-blue-600"
                                        : "border-transparent text-gray-500 hover:text-blue-600"
                                        }`}
                                >
                                    <MessageSquareText className="w-4 h-4 mr-2" />
                                    Chats
                                </button>
                                <button
                                    onClick={() => handleSwitchTab("contact")}
                                    className={`flex items-center px-4 py-2 text-sm font-medium border-b-2 justify-center w-full transition-colors ${activeTab === "contact"
                                        ? "border-blue-500 text-blue-600"
                                        : "border-transparent text-gray-500 hover:text-blue-600"
                                        }`}
                                >
                                    <UserRound className="w-4 h-4 mr-2" />
                                    Contacts
                                </button>
                            </div>
                        </div>
                    </header>

                    <main className="  w-full bg-white border-l border-gray-200 overflow-y-auto ">

                        {activeTab === 'chat' ? <div className="divide-y divide-gray-200">
                            {activeChatOptions === 'All' && <div className="relative m-1">
                                <Search className="absolute left-3 top-2.5 text-gray-500" size={12} />
                                <input
                                    type="text"
                                    placeholder="Search"
                                    className="w-full bg-gray-200 py-2 pl-10 pr-4 rounded-xl text-sm text-black focus:outline-none shadow "

                                    value={searchVal}
                                    onChange={handleSearchUser}
                                />
                            </div>}

                            <div className="m-2 overflow-x-auto">
                                <div className="flex gap-1 items-start whitespace-nowrap mt-1">
                                    {tabs.map((tab, i) => (
                                        <span
                                            key={i + 1}
                                            onClick={() => handleChatFilter(tab)}
                                            className={`px-3  py-1 rounded-xl border border-primary text-[10px] cursor-pointer transition-all duration-200 ${activeChatOptions === tab
                                                ? `bg-[${color}] text-white`
                                                : 'bg-lite text-black'
                                                }`}
                                            style={{ backgroundColor: activeChatOptions === tab ? color : "#fff" }}
                                        >
                                            {tab}
                                        </span>
                                    ))}
                                </div>
                            </div>
                            {userList.map(user => (
                                <div
                                    key={user._id}
                                    className="p-3 flex items-center hover:bg-gray-50 cursor-pointer"
                                    onClick={() => handleUserClick(user)}
                                >
                                    <div className="relative" style={{ width: '20%' }}>
                                        {user?.profileImage ? <img
                                            src={user?.profileImage}
                                            alt={user.name?.charAt(0)}
                                            className="w-10 h-10 rounded-full items-center justify-center flex border"
                                        /> :
                                            user.type === 'group' ? <span className="w-10 h-10 rounded-full items-center justify-center flex border"
                                            ><Users /> </span> : <span className="w-10 h-10 rounded-full items-center justify-center flex border"
                                            >
                                                {user.name?.charAt(0)}
                                            </span>
                                        }
                                        {user.status === 'available' && (
                                            <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
                                        )}
                                        {user.status === 'Do not Disturb' && (
                                            <div className="absolute bottom-0 right-0 w-3 h-3 bg-yellow-500 rounded-full border-2 border-white"></div>
                                        )}
                                        {user.status === 'offline' && (
                                            <div className="absolute bottom-0 right-0 w-3 h-3 bg-gray-500 rounded-full border-2 border-white"></div>
                                        )}
                                        {user.type == "bot" && <div className="absolute bottom-0 right-0 w-3 h-3 ">  <BotIcon size={14} style={{ color: '#008293' }} /></div>
                                        }
                                    </div>
                                    <div className="ml-3 w-full">
                                        <div className="flex items-center justify-between">
                                            <div className="font-medium text-gray-900 truncate max-w-[8rem]">
                                                {user.name}
                                            </div>
                                            <div className="text-xs text-gray-400 whitespace-nowrap">
                                                {formatDate(user?.createdAt)}
                                            </div>
                                        </div>

                                        <div
                                            className={`flex items-center max-w-[13rem] truncate ${user.msg === "New"
                                                ? "text-sm font-bold text-black"
                                                : "text-xs text-gray-500"
                                                }`}
                                        >
                                            {user.isDeleted ? <span className="flex-1 truncate max-w-[10rem] italic">This message was deleted</span> : <span className="flex-1 truncate max-w-[10rem]">{user.messageContent}</span>}
                                            {user.unReadCount > 0 && (
                                                <span className="ml-2 text-xs text-white bg-red-500 rounded-full px-2 py-0.5 shrink-0 items-end">
                                                    {user.unReadCount}
                                                </span>
                                            )}
                                        </div>

                                    </div>



                                </div>
                            ))}
                        </div> : <div className="divide-y divide-gray-200">
                            <div className="relative m-1">
                                <Search className="absolute left-3 top-2.5 text-gray-500" size={12} />
                                <input
                                    type="text"
                                    placeholder="Contact Search"
                                    className="w-full bg-gray-200 py-2 pl-10 pr-4 rounded-xl text-sm text-black focus:outline-none shadow "

                                    value={searchContactVal}
                                    onChange={handleContactSearch}
                                />
                            </div>
                            {contactList.map(user => (
                                <div
                                    key={user._id}
                                    className="p-3 flex items-center hover:bg-gray-50 cursor-pointer"
                                    onClick={() => handleUserClick(user)}
                                >
                                    <div className="relative">
                                        {user?.profileImage ? <img
                                            src={user?.profileImage}
                                            alt={user.name.charAt(0)}
                                            className="w-10 h-10 rounded-full items-center justify-center flex border"
                                        /> : <span className="w-10 h-10 rounded-full items-center justify-center flex border"
                                        >{user.name.charAt(0)}</span>}
                                        {user.status === 'available' && (
                                            <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white"></div>
                                        )}
                                    </div>
                                    <div className="ml-3">
                                        <div className="font-medium text-gray-900">{user.name}</div>
                                        <div className="text-xs text-gray-500">{user.lastSeen}</div>
                                    </div>
                                </div>
                            ))}
                        </div>}
                    </main>
                </div>}
            </div>

            {
                showPreviewDialog && <PreviewDialog
                    showPreviewDialog={showPreviewDialog}
                    fileToUpload={fileToUpload}
                    handleCancelFileUpload={handleCancelFileUpload}
                    fetchUploadFileApi={fetchUploadFileApi}
                    color={color}
                />
            }
        </div >
    );
}
export default ChatWindows
